import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../sessionStorage';

export default function CustomerSupportEmail() {
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  var email = "insuranceapplication@covrtech.com";

  if (accountObj && accountObj.account && accountObj.account.customerSupportEmail) {
    email = accountObj.account.customerSupportEmail;
  }

  return email;
}
